import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { postAllData } from '../../../service/ProductService';
import { DDREPORT, DOWNLOADDDREPORT, DOWNLOADPROVIORIREPORT, PROVISIONALORIGINALREPORT } from '../../../config/ApiConstant';
import { DDReportListColumns, ProvOrgReportListColumns } from '../../../appconfig/DatatableSetting';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { downloadData, exportData } from '../../../appconfig/AppHelper';
import { amountTemplate, combinedFullNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const ProvOrgCertificateReport = () => {
    document.title = 'Provisional Original Certificate Registration Report | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [DDReportList, setDDReportList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);
    const [showButton, setShowButton] = useState<boolean>(false);

    // Date Object
    let today = new Date();
    const [dates, setDates] = useState({
        start: new Date(today.setDate(today.getDate() - 30)),
        end: new Date()
    });
    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });
    };
    useEffect(() => {
        getProvOrgDetails();
    }, []);

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-download" label="Download" onClick={() => downloadAllData()} className="mx-2" loading={loading} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //downloadDAta
    const downloadAllData = async () => {
        try {
            setLoading(true);

            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            // Request Data
            const requestData = {
                start_date: startDate,
                end_date: endDate
            };

            const response = await downloadData(DOWNLOADPROVIORIREPORT, 'Prov_Org_Certificate_Report', requestData);
            if (response === true) {
                setLoading(false);
            } else if (response === false) {
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('Prov_Org_Certificate_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getProvOrgDetailsList
    const getProvOrgDetails = async () => {
        try {   
            setPageLoad(false);
            setShowLoading(true);

            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            // Request Data
            const requestData = {
                start_date: startDate,
                end_date: endDate
            };

            const response = await postAllData(PROVISIONALORIGINALREPORT, requestData);

            if (response) {
                setPageLoad(true);
                setShowLoading(false);
                setDDReportList(response);
                setShowButton(true);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoading(false);
                setShowButton(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'Provisional Original Certificate Registration Report'} pageTitle={'Provisional Original Certificate Registration Report'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={DDReportList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {ProvOrgReportListColumns.map((col: any, i: any) => {
                                        if (col.field === 'OrgIDt' || col.field === 'ProIDate' || col.field === 'RegDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'name') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={combinedFullNameTemplate} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ProvOrgReportListColumns.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
